import React from "react";
import { Select, MenuItem, Box, ListItemIcon, ListItemText } from "@mui/material";
import { CaretDown } from "@phosphor-icons/react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import * as selectors from "selectors";
import { getSidebarConfig } from "./sidebarConfig";

export const MobileNavSelect: React.FC = () => {
  const history = useHistory();
  const { id, section } = useParams<{ id: string; section: string }>();
  const userPermissions = useSelector(selectors.getUserPermissionsList);
  const sidebarConfig = getSidebarConfig(userPermissions);

  const allItems = sidebarConfig.flatMap((item) =>
    "items" in item ? item.items : [item]
  );

  const currentItem = allItems.find((item) => item.path === section) || allItems[0];

  const handleChange = (event: any) => {
    const newPath = event.target.value;
    history.push(`/clients/${id}/${newPath}`);
  };

  return (
    <Select
      value={currentItem.path}
      onChange={handleChange}
      fullWidth
      IconComponent={CaretDown}
      sx={{
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "8px 16px",
        },
      }}
    >
      {allItems.map((item) => {
        const Icon = item.icon;
        return (
          <MenuItem key={item.path} value={item.path} sx={{ gap: "8px" }}>
            <ListItemIcon sx={{ minWidth: "unset" }}>
              <Icon size={20} weight="duotone" />
            </ListItemIcon>
            <ListItemText primary={item.label} />
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default MobileNavSelect;